<template>
	<div ref="stockEl" class="select_country">
		<div class="country_wrapper" @click="onToggleStock">
			<img
				v-if="headerStore.getCountry === 'KR'"
				src="@/assets/img/common/southkorea.svg"
				alt="한국 국기"
				loading="lazy"
			/>
			<img
				v-else-if="headerStore.getCountry === 'JPN'"
				src="@/assets/img/common/japan.svg"
				alt="일본 국기"
				loading="lazy"
			/>
			<img v-else src="@/assets/img/common/america.svg" alt="미국 국기" loading="lazy" />
			<span>{{ countryLabel }}</span>
			<img class="icon_down" src="@/assets/img/common/arrow_down.svg" alt="국가 선택 열기" loading="lazy" />
		</div>

		<MoreStock v-if="Boolean(route.query.isCountryMenuOpen)" />
	</div>
</template>

<script setup lang="ts">
// core
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { onClickOutside } from '@vueuse/core';

import MoreStock from '@/components/layout/header/CountryMenu/MoreStock.vue';
import { useHeaderStore } from '@/stores/header';
import { closeMenuModal, openMenuModal } from '@/utils/function/modalMenu';

const headerStore = useHeaderStore();
const route = useRoute();
const stockEl = ref();

const countryLabel = computed(() => {
	return headerStore.getCountry === 'KR' ? '한국주식' : headerStore.getCountry === 'JPN' ? '일본주식' : '미국주식';
});

// 국내/해외 토글 함수
const onToggleStock = () => {
	openMenuModal({ menu: 'Country' });
};

onClickOutside(stockEl, () => {
	if (route.query.isCountryMenuOpen) {
		closeMenuModal();
	}
});
</script>

<style lang="scss" scoped>
.select_country {
	position: relative;
	width: fit-content;
}
.country_wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	width: fit-content;
	gap: 0.8rem;
	border-radius: var(--border-radius-full);
	background-color: var(--color-bg-mid);
	padding: 0.6rem 0.6rem 0.6rem 0.8rem;
	font-weight: var(--font-w-light);
	font-size: var(--font-s-mid);
	line-height: 1.9rem;
	cursor: pointer;
	img {
		width: 2rem;
		height: 2rem;
	}
	.icon_down {
		width: 1.8rem;
	}
}
// .select_country {
// 	display: flex;
// 	justify-content: center;
// 	align-items: center;
// 	position: relative;
// 	gap: 0.8rem;
// 	border-radius: var(--border-radius-full);
// 	background-color: var(--color-bg-mid);
// 	padding: 0.6rem 0.6rem 0.6rem 0.8rem;
// 	font-weight: var(--font-w-light);
// 	font-size: var(--font-s-mid);
// 	line-height: 1.9rem;
// 	cursor: pointer;
// 	.icon_down {
// 		width: 1.8rem;
// 	}
// }
</style>
